export enum TaskStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  DISCARDED = "DISCARDED",
}
